module.exports = __webpack_public_path__ + "img/combosdk-top.af9b785.png";